// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./MabryPro-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./MabryPro-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./MabryPro-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./MabryPro-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./MabryPro-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./MabryPro-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("MabryPro-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("MabryPro-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("MabryPro-Light.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Mabry Pro";
  src: local("Mabry Pro Regular"), local("Mabry-Pro-Regular"),
    url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff"),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: "Mabry Pro Bold";
  src: local("Mabry Pro Bold"), local("Mabry-Pro-Bold"),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff"),
    url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("truetype");
  font-weight: 700;
  font-style: normal;
}

@font-face {
  font-family: "Mabry Pro Light";
  src: local("Mabry Pro Light"), local("Mabry-Pro-Light"),
    url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("woff"),
    url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("truetype");
  font-weight: 300;
  font-style: normal;
}

.font-mabry {
  font-family: "Mabry Pro", sans-serif;
}

.font-mabry-bold {
  font-family: "Mabry Pro Bold", sans-serif;
}

.font-mabry-light {
  font-family: "Mabry Pro Light", sans-serif;
}
`, "",{"version":3,"sources":["webpack://./src/fonts/style.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB;;;8DAGkD;EAClD,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B;;;8DAG+C;EAC/C,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B;;;8DAG8C;EAC9C,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;AAC5C","sourcesContent":["@font-face {\n  font-family: \"Mabry Pro\";\n  src: local(\"Mabry Pro Regular\"), local(\"Mabry-Pro-Regular\"),\n    url(\"./MabryPro-Regular.woff2\") format(\"woff2\"),\n    url(\"./MabryPro-Regular.woff\") format(\"woff\"),\n    url(\"./MabryPro-Regular.ttf\") format(\"truetype\");\n  font-weight: 400;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Mabry Pro Bold\";\n  src: local(\"Mabry Pro Bold\"), local(\"Mabry-Pro-Bold\"),\n    url(\"./MabryPro-Bold.woff2\") format(\"woff2\"),\n    url(\"./MabryPro-Bold.woff\") format(\"woff\"),\n    url(\"./MabryPro-Bold.ttf\") format(\"truetype\");\n  font-weight: 700;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Mabry Pro Light\";\n  src: local(\"Mabry Pro Light\"), local(\"Mabry-Pro-Light\"),\n    url(\"MabryPro-Light.woff2\") format(\"woff2\"),\n    url(\"MabryPro-Light.woff\") format(\"woff\"),\n    url(\"MabryPro-Light.ttf\") format(\"truetype\");\n  font-weight: 300;\n  font-style: normal;\n}\n\n.font-mabry {\n  font-family: \"Mabry Pro\", sans-serif;\n}\n\n.font-mabry-bold {\n  font-family: \"Mabry Pro Bold\", sans-serif;\n}\n\n.font-mabry-light {\n  font-family: \"Mabry Pro Light\", sans-serif;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
